// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 4rem;
  min-height: 4rem;
  padding: 0 1.5rem;
  background: var(--surface-primary);
  border-bottom: 1px solid var(--border-default);
  z-index: 50;
}

.top-bar-left {
  display: flex;
  align-items: center;
}
.top-bar-left .page-title {
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary);
}`, "",{"version":3,"sources":["webpack://./src/app/components/top-bar/top-bar.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,kCAAA;EACA,8CAAA;EACA,WAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;AACE;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;AACJ","sourcesContent":[".top-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 4rem;\n  min-height: 4rem;\n  padding: 0 1.5rem;\n  background: var(--surface-primary);\n  border-bottom: 1px solid var(--border-default);\n  z-index: 50;\n}\n\n.top-bar-left {\n  display: flex;\n  align-items: center;\n\n  .page-title {\n    font-size: 1rem;\n    font-weight: 600;\n    color: var(--text-primary);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
